import script from "./ProjectPublicAccess.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectPublicAccess.vue?vue&type=script&setup=true&lang=js"

import "./ProjectPublicAccess.vue?vue&type=style&index=0&id=0b81dd5d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b81dd5d"]])

export default __exports__